import {
  Component,
  EventEmitter,
  Output
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faFacebookF,
  faFlickr,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-footer',
  imports: [FontAwesomeModule, MatTooltipModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  faFacebook = faFacebookF;
  faX = faXTwitter;
  faLinkedIn = faLinkedinIn;
  faInstagram = faInstagram;
  faFlickr = faFlickr;

   currentYear: number = new Date().getFullYear();

  @Output() scrollToTopEmitter = new EventEmitter();

  scrollToTop() {
    this.scrollToTopEmitter.emit();
  }
}
